import React, { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';
import './AboutCharity.scss';
import PageList from '../PageList/PageList';
import AboutRelationship from '../AboutRelationship/AboutRelationship';
import CharityRegNumber from '../CharityRegNumber/CharityRegNumber';

interface AboutCharityProps {
  charities: {
    id?: string;
    url?: string;
    logo: string;
    name?: string | null;
    profilePageUrl: string;
    description?: string | null;
    registrationNumber?: string | null;
  }[];
}

const AboutCharity: FunctionComponent<AboutCharityProps> = ({ charities }) => {
  if (charities.length > 1) {
    return (
      <>
        <PageList
          pages={charities.map(x => ({
            charityId: x.id,
            url: x.profilePageUrl,
            logo: x.logo,
          }))}
        />
        <FindOutMoreLink />
      </>
    );
  }

  if (charities.length === 1) {
    const charity = charities[0];
    return (
      <>
        <AboutRelationship
          logo={charity.logo}
          name={charity.name || ''}
          landingPageUrl={charity.profilePageUrl}
          description={charity.description}
          logoVariant="normal"
        >
          <CharityRegNumber className="jg-space-mbn" />
          {charity.url && (
            <p itemProp="url" className="jg-text--small-light jg-space-mbn">
              {charity.url}
            </p>
          )}
        </AboutRelationship>
        <FindOutMoreLink />
      </>
    );
  }

  return null;
};

const FindOutMoreLink = () => (
  <a
    href="/fundraising"
    target="_blank"
    className="jg-about-charity__link jg-space-mtsm"
  >
    <Trans i18nKey="charity.findOutMore">
      Find out more about charity fundraising
    </Trans>
  </a>
);

export default AboutCharity;
